import { render, staticRenderFns } from "./GestionRevision.vue?vue&type=template&id=f71fa382&"
import script from "./GestionRevision.vue?vue&type=script&lang=js&"
export * from "./GestionRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports